const Logo = () => {
  return (
    <div className="w-24 h-24 mx-auto mb-6 animate-fade-in flex items-center justify-center">
      <img
        src="/lovable-uploads/6b7992d9-cd07-4ae7-bbc1-77660d0a5a6d.png"
        alt="Clubbers Logo"
        className="w-20 h-20 drop-shadow-[0_0_15px_rgba(0,193,214,0.5)] transition-all duration-300 hover:scale-105 hover:drop-shadow-[0_0_25px_rgba(0,193,214,0.7)]"
      />
    </div>
  );
};

export default Logo;